import { atom } from "recoil";

import { IProductionPollGroupState, IRichLogData } from "../../models";

export const producePollingRunningCountAtom = atom<number>({
  key: "producePollingRunningCountAtom",
  default: 0,
});

export const productionLogStateAtom = atom<IRichLogData | undefined>({
  key: "productionLogStateAtom",
  default: undefined,
});

export const productionPollGroupStateAtom = atom<
  IProductionPollGroupState | undefined
>({
  key: "productionPollGroupStateAtom",
  default: undefined,
});
